import { defineNuxtPlugin, useHead } from '#imports';
import { MergeHead } from '@unhead/schema';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';
import { notRoutes } from '~/src/constants/rightPendant/index';
// 智齿客服
export default defineNuxtPlugin(nuxtApp => {
  let script: MergeHead['script'] = {};

  // if (GLOBAL_CONFIG.env === 'production') {
  // }
  const pinia: any = nuxtApp.payload?.pinia as any;
  script = {
    src: 'https://www.sobot.com/chat/frame/js/entrance.js?sysNum=a8d9379eaf884b4f81a48348979e3b1a',
    tagPosition: 'bodyClose',
    id: 'zhichiScript',
    class: 'zhiCustomBtn',
    dataArgs: 'manual=true',
    onload: () => {
      const tempWindow = window as any;

      if (tempWindow && tempWindow.getzhiSDKInstance) {
        const zhiManager = tempWindow.getzhiSDKInstance();
        zhiManager.on('load', function () {
          zhiManager.initBtnDOM();
        });
        zhiManager.set('title', '欢迎咨询');
        zhiManager.set('powered', false);
        zhiManager.set('customBtn', 'true');
        zhiManager.set('size', { width: 360, height: 500 });
        zhiManager.set('userinfo', {
          partnerId: pinia.user?.userInfo?.userId || '',
          uname: `${pinia?.user?.userInfo?.nickName || ''}`,
          params: `{"用户名":"${pinia?.user?.userInfo?.nickName || ''}"}`,
        });
        zhiManager.set('customMargin', 20);
        zhiManager.set('preVisitArgs', { preVisitUrl: document.referrer ? document.referrer : '' });
        zhiManager.set('curVisitArgs', {
          curVisitUrl: location.href,
          curVisitTitle: document.title,
        });
      }
    },
  };

  if (
    process.client &&
    !notRoutes.includes(nuxtApp._route.name as string) &&
    !pinia?.environment?.isMobile
  ) {
    useHead({
      script: [script],
    });
  }
});
